<template>
  <header class="page-header-block">
    <div class="page-header-block__left">
      <div class="page-header-block__title-row">
        <i v-if="icon" :class="['page-header-block__desktop-icon', icon]"></i>
        <button
          aria-label="Geri"
          class="page-header-block__mobile-back"
          type="button"
          @click="goBack"
        >
          <i class="uil-arrow-left"></i>
        </button>
        <span class="page-header-block__title">
          <slot>{{ title }}</slot>
        </span>
      </div>
    </div>

    <div v-if="$slots.right" class="page-header-block__right">
      <slot name="right"></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    backRoute: {
      type: [String, Object],
      default: null
    },
    backFallback: {
      type: String,
      default: ""
    }
  },
  methods: {
    goBack() {
      const targetRoute = this.backRoute || this.backFallback || {
        name: "user.index"
      }
      const resolvedRoute = this.$router.resolve(targetRoute).route

      if (resolvedRoute.fullPath !== this.$route.fullPath) {
        this.$router.push(targetRoute)
      }
    }
  }
};
</script>

<style scoped>
.page-header-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 12px;
}

.page-header-block__left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.page-header-block__title-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
  flex: 1;
}

.page-header-block__desktop-icon {
  flex-shrink: 0;
  color: var(--backgroundColor, #666CFF);
  font-size: 22px;
}

.page-header-block__title {
  min-width: 0;
  overflow: hidden;
  color: #1e293b;
  font-family: var(--font-secondary);
  font-size: 20px;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.page-header-block__right {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 12px;
}

.page-header-block__mobile-back {
  display: none;
}

@media (max-width: 768px) {
  .page-header-block {
    align-items: center;
    gap: 12px;
    margin-bottom: 4px;
  }

  .page-header-block__desktop-icon {
    display: none;
  }

  .page-header-block__left {
    width: 100%;
  }

  .page-header-block__title-row {
    min-height: 44px;
    gap: 8px;
  }

  .page-header-block__mobile-back {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--backgroundColor, #666CFF);
    cursor: pointer;
    font-size: 36px;
    line-height: 1;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .page-header-block__mobile-back i {
    font-size: 36px;
    line-height: 1;
  }

  .page-header-block__mobile-back:focus-visible {
    outline: 2px solid var(--backgroundColor, #666CFF);
    outline-offset: 2px;
  }

  .page-header-block__title {
    font-size: 20px;
    line-height: 1.25;
  }

  .page-header-block__right {
    align-self: center;
  }
}

@media (max-width: 480px) {
  .page-header-block {
    flex-wrap: wrap;
    margin-bottom: 4px;
  }

  .page-header-block__title {
    font-size: 18px;
  }

  .page-header-block__right {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
